<app-admin-nav></app-admin-nav>
<div class="board">
  <div class="head">
    <div>
      <h2>Abuse board</h2>
      <p class="sub">
        What the spam guard has caught, and what the ecosystem looks like around it.
        Organic traffic runs at one to three new conversations a day — a day that
        stands well above its neighbours is worth opening before anything is flagged.
      </p>
    </div>
    <button mat-stroked-button (click)="load()" [disabled]="loading">Refresh</button>
  </div>

  <div class="stats" *ngIf="overview">
    <div class="stat" [class.alert]="overview.appealsWaiting > 0">
      <div class="n">{{ overview.appealsWaiting }}</div><div class="l">Appeals waiting</div>
    </div>
    <div class="stat" [class.alert]="overview.awaitingReview > 0">
      <div class="n">{{ overview.awaitingReview }}</div><div class="l">Awaiting review</div>
    </div>
    <div class="stat"><div class="n">{{ overview.bannedTotal }}</div><div class="l">Banned</div></div>
    <div class="stat" [class.alert]="overview.reports24h > 0">
      <div class="n">{{ overview.reports24h }}</div><div class="l">Reports 24h</div>
    </div>
    <!-- Blocks carry no timestamp, so this is a running total and not a 24h
         window like the one beside it. Deliberately not an alert: blocks are
         normal, and a card that is permanently red teaches you to stop seeing
         it. What needs doing is on the Complaints tab, which counts the ones
         nobody has reviewed. -->
    <div class="stat">
      <div class="n">{{ blocksTotal }}</div><div class="l">Blocks</div>
    </div>
    <div class="stat"><div class="n">{{ overview.signups24h }}</div><div class="l">Signups 24h</div></div>
    <div class="stat"><div class="n">{{ overview.openFlags }}</div><div class="l">Open flags</div></div>
  </div>

  <app-daily-bars *ngIf="overview?.daily?.length" title="New conversations per day" [bars]="dailyBars" [labels]="true">
    counters start the day the board shipped
  </app-daily-bars>

  <div class="tabs">
    <button [class.on]="tab === 'appeals'" (click)="tab = 'appeals'" [class.hot]="openAppeals.length > 0">
      Appeals ({{ openAppeals.length }})
    </button>
    <button [class.on]="tab === 'cases'" (click)="tab = 'cases'">Cases ({{ cases.length }})</button>
    <button
      [class.on]="tab === 'complaints'"
      (click)="tab = 'complaints'"
      [class.hot]="unreviewedComplaints.length > 0">
      Complaints ({{ unreviewedComplaints.length }}/{{ complaints.length }})
    </button>
    <button [class.on]="tab === 'watchlist'" (click)="tab = 'watchlist'">Watchlist ({{ personas.length }})</button>
    <button [class.on]="tab === 'archives'" (click)="tab = 'archives'">Archives ({{ archives.length }})</button>
    <button [class.on]="tab === 'thresholds'" (click)="tab = 'thresholds'">Thresholds</button>
  </div>

  <div class="notice ok" *ngIf="notice">{{ notice }}</div>
  <div class="notice bad" *ngIf="error">{{ error }}</div>
  <div class="loading" *ngIf="loading"><mat-spinner diameter="28"></mat-spinner></div>

  <table *ngIf="!loading && tab === 'appeals' && appeals.length">
    <thead>
      <tr>
        <th>Who</th><th>Status</th><th>Due</th><th>What they said</th><th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let a of appeals" [attr.data-status]="a.status">
        <td>
          <div class="title">
            <app-person-link
              [uid]="a.uid"
              [name]="a.profile?.name || a.email"
              (failed)="error = $event"
            ></app-person-link>
          </div>
          <div class="meta">{{ a.email }}</div>
          <div class="meta" *ngIf="!a.uid">no account matched — check this</div>
        </td>
        <td>
          <span class="pill" [attr.data-status]="a.status === 'open' ? 'flagged' : (a.status === 'restored' ? 'clear' : 'banned')">
            {{ a.status === 'open' ? 'Waiting' : (a.status === 'restored' ? 'Restored' : 'Upheld') }}
          </span>
          <div class="meta" *ngIf="!a.withinWindow">ban over 30 days old</div>
          <div class="meta" *ngIf="a.status !== 'open'">by {{ a.decidedBy }}</div>
        </td>
        <td class="meta" [class.hot]="isOverdue(a)">
          {{ a.status === 'open' ? dueLabel(a) : '—' }}
        </td>
        <td class="reasons">
          <div>{{ a.reachingOut || a.broughtYou }}</div>
          <div class="meta" *ngIf="a.placeYou">{{ a.placeYou }}</div>
        </td>
        <td class="actions">
          <a mat-stroked-button *ngIf="a.uid" [routerLink]="['/admin/abuse', a.uid]">Open case</a>
        </td>
      </tr>
    </tbody>
  </table>
  <p class="empty" *ngIf="!loading && tab === 'appeals' && !appeals.length">
    Nobody has appealed. Every ban carries a link to the form, so an empty list
    means either the guard is only catching scammers or nobody has tried.
  </p>

  <table *ngIf="!loading && tab === 'cases' && cases.length">
    <thead>
      <tr>
        <th>Account</th><th>Status</th><th>Why</th>
        <th class="num">Chats</th><th class="num">Reports</th><th class="num">Blocks</th>
        <th>Last activity</th><th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let c of cases" [attr.data-status]="status(c)">
        <td>
          <div class="title">
            <app-person-link [uid]="c.uid" [name]="c.profile?.name" (failed)="error = $event"></app-person-link>
          </div>
          <div class="meta">{{ c.profile?.email || c.uid }}</div>
        </td>
        <td><span class="pill" [attr.data-status]="status(c)">{{ statusLabel(c) }}</span></td>
        <td class="reasons">
          <div *ngFor="let r of c.reasons">{{ r }}</div>
          <div class="meta" *ngIf="!c.reasons.length">—</div>
        </td>
        <td class="num">{{ c.chatCount }}</td>
        <td class="num" [class.hot]="c.reportCount > 0">{{ c.reportCount }}</td>
        <td class="num" [class.hot]="c.blockCount > 0">{{ c.blockCount }}</td>
        <td class="meta">{{ (c.updatedAt || c.bannedAt) ? ((c.updatedAt || c.bannedAt) | date: 'd MMM, HH:mm') : '—' }}</td>
        <td class="actions">
          <a mat-stroked-button [routerLink]="['/admin/abuse', c.uid]">Open</a>
        </td>
      </tr>
    </tbody>
  </table>
  <p class="empty" *ngIf="!loading && tab === 'cases' && !cases.length">
    Nothing flagged or banned. That is the expected state.
  </p>

  <ng-container *ngIf="!loading && tab === 'complaints'">
    <p class="sub">
      What members said themselves, rather than what the guard noticed. A report
      is someone taking the trouble to fill in a form; a block is someone
      walking away without telling anybody. Neither is a threshold the guard can
      measure, and an account can collect both without ever being flagged —
      those are the rows at the top.
    </p>

    <table *ngIf="complaints.length">
      <thead>
        <tr>
          <th>Account</th><th class="num">Reports</th><th class="num">Blocks</th>
          <th>Status</th><th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of complaints">
          <td>
            <div class="title">
              <app-person-link [uid]="c.uid" [name]="c.profile?.name" (failed)="error = $event"></app-person-link>
            </div>
            <div class="meta">{{ c.profile?.email || c.uid }}</div>
          </td>
          <td class="num" [class.hot]="c.reports > 0">{{ c.reports }}</td>
          <td class="num" [class.hot]="c.blocks > 0">{{ c.blocks }}</td>
          <td>
            <span class="pill" [attr.data-status]="c.banned ? 'banned' : (c.flagged ? 'flagged' : 'none')">
              {{ complaintStatus(c) }}
            </span>
          </td>
          <td class="actions">
            <a mat-stroked-button [routerLink]="['/admin/abuse', c.uid]">Open</a>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="empty" *ngIf="!complaints.length">
      Nobody has reported or blocked anyone. That is the expected state.
    </p>
  </ng-container>

  <table *ngIf="!loading && tab === 'watchlist' && personas.length">
    <thead>
      <tr><th>Name</th><th>Accounts</th><th>Last banned</th><th></th></tr>
    </thead>
    <tbody>
      <tr *ngFor="let p of personas">
        <td>
          <div class="title">{{ p.names.join(', ') }}</div>
          <div class="meta">{{ p.key }}</div>
        </td>
        <td class="meta">
          <ng-container *ngFor="let uid of p.uids; let i = index">
            <span *ngIf="i">, </span>
            <app-person-link [uid]="uid" [name]="uid" (failed)="error = $event"></app-person-link>
          </ng-container>
          <span *ngIf="!p.uids.length">—</span>
        </td>
        <td class="meta">{{ p.lastBannedAt ? (p.lastBannedAt | date: 'd MMM yyyy') : '—' }}</td>
        <td class="actions">
          <button mat-stroked-button color="warn" (click)="removePersona(p.key)" [disabled]="busyKey === p.key">
            {{ confirmingKey === p.key ? 'Confirm remove' : 'Remove' }}
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <p class="empty" *ngIf="!loading && tab === 'watchlist' && !personas.length">
    No names on the watchlist. A name here holds every future signup sharing it
    to tighter thresholds, so an empty list is the healthy one.
  </p>

  <table *ngIf="!loading && tab === 'archives' && archives.length">
    <thead>
      <tr><th>Account</th><th class="num">Chats</th><th class="num">Messages</th><th>Archived</th><th>Checksum</th></tr>
    </thead>
    <tbody>
      <tr *ngFor="let a of archives">
        <td>
          <div class="title">
            <app-person-link [uid]="a.uid" [name]="a.uid" (failed)="error = $event"></app-person-link>
          </div>
          <div class="meta">by {{ a.actor }}</div>
        </td>
        <td class="num">{{ a.chats }}</td>
        <td class="num">{{ a.messages }}</td>
        <td class="meta">{{ a.at ? (a.at | date: 'd MMM yyyy, HH:mm') : '—' }}</td>
        <td class="meta mono">{{ a.sha256 | slice: 0:16 }}…<div class="meta">{{ a.path }}</div></td>
      </tr>
    </tbody>
  </table>
  <p class="empty" *ngIf="!loading && tab === 'archives' && !archives.length">
    No chats have been archived yet.
  </p>

  <ng-container *ngIf="tab === 'thresholds'">
    <p class="sub thresholds-intro">
      The numbers the spam guard decides on. Everything is counted over a rolling
      24 hours, per account. <b>Flag</b> means you get one email and the account
      appears in Cases — the person is not affected. <b>Ban</b> means the account
      is signed out and blocked from writing immediately, which is the one to be
      careful with. Changes take effect within a minute, no deploy needed.
    </p>

    <div class="tgroup" *ngFor="let group of thresholdGroups">
      <h3>{{ group.name }}</h3>
      <div class="trow" *ngFor="let row of group.rows" [class.bans]="row.bans">
        <div class="tmain">
          <div class="tlabel">
            {{ row.label }}
            <span class="tag" [class.ban]="row.bans">{{ row.bans ? 'bans' : 'flags' }}</span>
            <span class="tag changed" *ngIf="row.overridden">changed from {{ row.defaultValue }}</span>
          </div>
          <p class="tdesc">{{ row.description }}</p>
        </div>
        <div class="tedit">
          <input
            type="number"
            [value]="shownValue(row)"
            [min]="row.min"
            [max]="row.max"
            [class.bad]="outOfRange(row)"
            (input)="onThresholdInput(row, $event)"
            [disabled]="savingThresholds"
          />
          <span class="tunit">{{ row.unit }}</span>
          <button
            mat-stroked-button
            class="treset"
            (click)="resetToDefault(row)"
            [disabled]="savingThresholds || shownValue(row) === row.defaultValue"
          >
            Default ({{ row.defaultValue }})
          </button>
          <div class="trange" [class.bad]="outOfRange(row)">
            {{ row.min }}–{{ row.max }}
          </div>
        </div>
      </div>
    </div>

    <div class="tsave" *ngIf="thresholdGroups.length">
      <span class="meta" *ngIf="!editedKeys.length">
        Nothing changed yet.
      </span>
      <span class="meta" *ngIf="editedKeys.length">
        {{ editedKeys.length }} change{{ editedKeys.length === 1 ? '' : 's' }} not saved.
      </span>
      <button mat-stroked-button (click)="discardThresholdEdits()" [disabled]="!editedKeys.length || savingThresholds">
        Discard
      </button>
      <button mat-flat-button color="primary" (click)="saveThresholds()" [disabled]="!canSaveThresholds">
        {{ savingThresholds ? 'Saving…' : 'Save thresholds' }}
      </button>
    </div>
  </ng-container>
</div>
